module.exports = "/_next/static/images/5e8bdf5a26ad6cc083ee722334a5f4c0-girl-with-card-xs.png";